import React from 'react';
import Dialog from 'lib/components/Dialog';
import { gotoBenefitMiniProgram } from 'lib/utils/goto-outside';
import './qrcode.scss';

interface QRCodeDialogProps {
  title: string;
  content: string;
  confirmButtonText?: string | React.ReactNode;
  confirmCallback?: () => void;
  showClose?: boolean;
  footer?: React.ReactNode;
}

const QRCodeDialog = ({
  title,
  content,
  confirmButtonText = '',
  confirmCallback,
  showClose = false,
  footer,
}: QRCodeDialogProps) => (
  <Dialog showClose={showClose} title={title} confirmButtonText={confirmButtonText} confirmCallback={confirmCallback}>
    <div className="ordering-dialog">
      <div className="ordering-dialog__text">
        <span>{content}。</span>请截图保存此二维码至手机相册，点击图片，
        <span>关注「腾讯福利鹅」公众号，查收后续领奖提醒</span>
      </div>
      <div className="ordering-dialog__qrcode" onClick={() => gotoBenefitMiniProgram('order')}>
        <img className="img" src="//obd.gtimg.com/assets/img/3c8ec43b732217d903506e0a49c3d7fc20ff0fe6.png" />
      </div>
      {footer ? <div className="ordering-dialog__footer">{footer}</div> : null}
    </div>
  </Dialog>
);

export default QRCodeDialog;
